const obj = {
  id: '',
  adminPlusEventId: '',
  config: '',
  value: '',
}

export default function ConfigValueModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
